import { getSubAppPathRegexp } from '@/layouts/sfapp';
import { projectSettings } from '@/settings/index';

/**
 * 默认布局组件
 */
export const DEFAULT_LAYOUT = () => import('../layouts/default.vue');

/**
 * index路由
 */
export const INDEX_ROUTE = {
  path: '/',
  title: '品质工作台',
  meta: {
    hideInMenu: true,
    noAffix: true,
  },
  children: [
    {
      name: 'home',
      path: '/front/home',
      meta: {
        hideInMenu: true,
        noAffix: true,
      },
    }
  ]
};

/**
 * 404路由
 */
export const NOT_FOUND_ROUTE = {
  path: '/:path(.*)*',
  name: 'notFound',
  component: () => import('@/pages/[...all].vue'),
  meta: {
    title: '',
    hideInMenu: true,
  },
};

/**
 * 重新加载
 */
export const RELOAD_ROUTE = {
  path: '/reload',
  name: 'reload',
  component: () => import('@/pages/reload.vue'),
  meta: {
    title: '重新加载',
    hideInMenu: true,
    noAffix: true,
  },
};

export const SUB_APP_ROUTES =
  projectSettings.subApps?.map(({ name }) => {
    return {
      path: getSubAppPathRegexp(name),
      name: '页面',
      component: () => import('@/pages/sub_apps/index.vue'),
      meta: {
        hideInMenu: true,
        isSubApp: true,
      },
    };
  }) || [];
